"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "combineContainerMixins", {
  enumerable: true,
  get: function () {
    return _createContainer.combineContainerMixins;
  }
});
Object.defineProperty(exports, "makeCreateContainerFunction", {
  enumerable: true,
  get: function () {
    return _createContainer.makeCreateContainerFunction;
  }
});
Object.defineProperty(exports, "createContainer", {
  enumerable: true,
  get: function () {
    return _createContainer.createContainer;
  }
});

var _createContainer = require("./create-container");


//////////////////
// WEBPACK FOOTER
// ./~/victory-create-container/lib/index.js
// module id = 1878
// module chunks = 0